const IMPERSONATION_ACCESS_TOKEN_KEY = 'optimo_impersonation_access_token';
const IMPERSONATION_TARGET_USER_ID_KEY = 'optimo_impersonation_target_user_id';

export const getPersistedImpersonation = (): { accessToken: string | null; targetUserId: string | null } => ({
  accessToken: localStorage.getItem(IMPERSONATION_ACCESS_TOKEN_KEY),
  targetUserId: localStorage.getItem(IMPERSONATION_TARGET_USER_ID_KEY),
});

export const persistImpersonation = (accessToken: string, targetUserId: string): void => {
  localStorage.setItem(IMPERSONATION_ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(IMPERSONATION_TARGET_USER_ID_KEY, targetUserId);
};

export const clearPersistedImpersonation = (): void => {
  localStorage.removeItem(IMPERSONATION_ACCESS_TOKEN_KEY);
  localStorage.removeItem(IMPERSONATION_TARGET_USER_ID_KEY);
};
